module.exports = __webpack_public_path__ + "img/Documentation.2ec37fc2.svg";